export default {
    queuedBookings: {
        listing: [],
        isLoading: false,
        isFetched: false,
        totalFilter: 0,
        total: 0
    },
    selectedQueuedBooking: null,
    queuedBookingSubmitted: {
        isLoading: false,
        isSubmitted: false,
        error: false,
        message: '',
        submitAction: ''
    }
}